import { DocumentId } from '@/types';
import client from './client';

async function get() {
  const { data } = await client.get<DocumentId[]>(`/documentsIds`);
  return data;
}

async function getByDocId(documentId: string) {
  const { data } = await client.get<DocumentId>(`/documentsIds/${documentId}`);
  const { docId, enabled } = data;
  return {
    docId,
    enabled,
  };
}

async function update({ id, enabled, docId }: { id: string; enabled: string; docId: string }) {
  const { data } = await client.patch<DocumentId>(`/documentsIds/${id}`, {
    docId,
    enabled,
  });
  return data;
}

export const documentsIds = {
  get,
  update,
  getByDocId,
};
